import * as React from "react";
import classnames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { useDrawer } from "../../../../../context/Drawer/context/DrawerContext.js";
/* empty css                   */
import { lockScroll, unlockScroll } from "../../../../../../Util/Util/scroll-lock.js";
import { useStackedHandleOnEscape } from "../../../../../../EscapeHandlerStack/hooks/EscapeHandlerStack/hooks/use-stacked-handle-on-escape.js";
import { FocusTrap } from "../../../../../../FocusTrap/FocusTrap/FocusTrap.js";
const transition = { ease: "easeInOut", duration: 0.3 };
const verticalOverlayVariants = {
  open: {
    x: "0",
    y: "0",
    transition
  },
  closed: {
    y: "0",
    x: "100%",
    transition
  }
};
const horizontalOverlayVariants = {
  open: {
    y: "0",
    x: "0",
    transition
  },
  closed: {
    y: "100%",
    x: "0",
    transition
  }
};
const DrawerOverlay = ({
  children,
  "data-t": dataT,
  shouldMountContent = false,
  disableInitialFocus = false
}) => {
  const { isOpen, close, direction } = useDrawer();
  React.useEffect(() => {
    if (isOpen) {
      lockScroll();
      return () => unlockScroll();
    }
  }, [isOpen]);
  useStackedHandleOnEscape({ isOpen, handler: close });
  const isActive = shouldMountContent || isOpen;
  return /* @__PURE__ */ React.createElement(AnimatePresence, null, isActive && /* @__PURE__ */ React.createElement(
    FocusTrap,
    {
      active: isOpen,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        initialFocus: disableInitialFocus ? false : void 0
      }
    },
    /* @__PURE__ */ React.createElement(
      motion.div,
      {
        "data-t": dataT,
        role: "dialog",
        key: "drawer-overlay",
        className: classnames("drawer-overlay", `drawer-overlay--${direction}`),
        variants: direction === "bottom" ? horizontalOverlayVariants : verticalOverlayVariants,
        animate: isOpen ? "open" : "closed",
        inert: !isOpen ? "" : void 0,
        "aria-hidden": !isOpen,
        initial: "closed",
        exit: "closed"
      },
      children
    )
  ));
};
export {
  DrawerOverlay
};
//# sourceMappingURL=DrawerOverlay.js.map
